/* Built In Imports */
import { Fragment, useEffect, useState } from 'react';

/* External Imports */
import { Box, Center, Show } from '@chakra-ui/react';
import LiteYouTubeEmbed from 'react-lite-youtube-embed';

/* Internal Imports */
/* Components */
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import { setAudioPlayer } from '@ihs/components/Utility/utils';

/* Services */
/* Styles */
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';

/**
 * Renders the Article component
 *
 * @param {object} articleData - data
 * @param {string} language - Language of the page
 * @param {boolean} isLikeBookmarkVisible
 * @param {Array} updateCards
 * @returns {ReactElement} Article component
 */

const Article = ({
    articleData,
    type
}) => {
    const [isAudioLoad, setAudioLoad] = useState(false);
    const [youtubeID, setYoutubeID] = useState('');
    const handleAudioClick = () => {
        if (!isAudioLoad) {
            setAudioLoad(true);
        }
    };
    useEffect(() => {
        if (typeof window !== 'undefined' && type == 'audio' && isAudioLoad) {
            setAudioPlayer(articleData?.mediaUrl[0]?.value[0]?.embedUrl);
        }
    }, [isAudioLoad]);
    useEffect(() => {
        if (type === 'video') {
            const url = articleData?.mediaUrl[0]?.value[0]?.embedUrl;
            const VID_REGEX =
                /(?:youtube(?:-nocookie)?\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
            const id = url.match(VID_REGEX)[1];
            setYoutubeID(id);
        }
    });

    return (
        <Fragment>
            <Box
                as="span"
                position="relative"
                display="block"
            >
                <Box>
                    {type === 'video' ? (
                        articleData?.mediaUrl[0]?.value[0]?.embedUrl && (
                            <Box
                                pos="relative"
                                w={{ base: '100%', md: '96%', lg: '100%' }}
                                m="0 auto 30px"
                                maxH={{ base: '206px', sm: '300px', md: '350px', lg: '391px' }}
                            >
                                <LiteYouTubeEmbed id={youtubeID} cookie={true} />
                            </Box>
                        )
                    ) : (
                        <LazyLoadImageComponent
                            minH={{ base: '206px', sm: '300px', md: '350px', lg: '391px' }}
                            src={
                                articleData?.heroImage?.[0]?.value &&
                                articleData?.heroImage?.[0]?.value?.url
                            }
                            alt={
                                articleData?.heroImage?.[0]?.value &&
                                articleData?.heroImage?.[0]?.value?.alt
                            }
                            title={
                                articleData?.heroImage?.[0]?.value &&
                                articleData?.heroImage?.[0]?.value?.alt
                            }
                        />
                    )}{' '}
                </Box>
                {type == 'audio' &&
                    articleData?.mediaUrl?.[0]?.value[0]?.embedUrl && (
                        <Box className="audio-player" pos="absolute" bottom={0} zIndex={100} h={{ base: "46px", md: "67px" }} _before={{
                            content: "''",
                            opacity: '0.45',
                            background: '#000000',
                            width: "100%",
                            height: "100%",
                            pos: "absolute"
                        }} width='100%'
                            fontFamily='arial'
                            color='rgb(255 255 255)'
                            fontSize='0.75em'
                            overflow='hidden'>
                            <Box className="timeline"
                                background="#D9D9D9"
                                position='absolute'
                                top={{ base: "20px", md: "30px" }}
                                left={{ base: "56px", md: '75px' }}
                                w={{ base: "80%", md: '85%' }}
                                cursor='pointer'
                                height='4px'>
                                <Box className="progress" background='#FBAD18'
                                    width='0%'
                                    height='100%'
                                    transition='0.25s'
                                    rounded='40px'></Box>
                            </Box>
                            <Box className="controls" padding={{ base: "0 14px", md: "0 20px" }}>
                                <Box className="play-container">
                                    <Center
                                        className="toggle-play play"
                                        margin={{ base: "5px 0 0 0", md: "10px 0 0 0" }}
                                        h={{ base: "32px", md: "40px" }}
                                        w={{ base: "32px", md: "40px" }}
                                        onClick={handleAudioClick}
                                        rounded="full"
                                    >
                                        <Show above='md'>

                                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                <path d="M12.5558 7.00087L3.11133 1.44531V12.5564L12.5558 7.00087Z" fill="#FBAD18" />
                                            </svg>
                                        </Show>
                                        <Show below='md'>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                                <g clip-path="url(#clip0_2199_19974)">
                                                    <path d="M11.0131 6.00129L3.24805 1.43359V10.569L11.0131 6.00129Z" fill="#FBAD18" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_2199_19974">
                                                        <rect width="10.9625" height="10.9625" fill="white" transform="translate(0.962891 0.519531)" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </Show>
                                    </Center>
                                </Box>
                                {/* <Box className="time">
                                    <Box className="current"></Box>
                                    <Box className="length"></Box>
                                </Box>
                                <Box className="volume-container">
                                    <Box className="volume-button">
                                        <Box className="volume icono-volumeMedium"></Box>
                                    </Box>
                                    <Box className="volume-slider">
                                        <Box className="volume-percentage"></Box>
                                    </Box>
                                </Box> */}
                            </Box>
                        </Box>
                    )}
            </Box>
            <style global jsx>
                {
                    `
         
          .audio-player .timeline .progress:after {
            width: 20px;
            background: #FBAD18;
            border-radius:40px;
            height: 20px;
          }
          .audio-player .controls {
            display: flex;
            justify-content: space-between;
            align-items: stretch;
          }
          .audio-player .controls > * {
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .audio-player .controls .toggle-play.play {
            cursor: pointer;
            position: relative;
            
            border: none;
            outline: none;
            background:#FFF;
          }
          
          .audio-player .controls .toggle-play.pause {
            position: relative;
            border: none;
            outline: none;
            background:#FFF;
          }

          .audio-player .controls .time {
            display: flex;
            margin-left: auto;
            color: #333;
            margin-top: -25px;
            font-family: 'FedraSerifAStdBook';
            font-size: 13px;
          }
          .audio-player .controls .time > * {
            padding: 2px;
          }
          .audio-player .controls .volume-container {
            cursor: pointer;
            position: relative;
            z-index: 2;
          }
          .audio-player .controls .volume-container .volume-button {
            height: 26px;
            display: flex;
            align-items: center;
          }
          .audio-player .controls .volume-container .volume-button .volume {
            transform: scale(0.7);
          }
          .audio-player .controls .volume-container .volume-slider {
            position: absolute;
            left: -3px;
            top: 15px;
            z-index: -1;
            width: 0;
            height: 15px;
            background: white;
            box-shadow: 0 0 20px #000a;
            transition: 0.25s;
          }
          .audio-player
            .controls
            .volume-container
            .volume-slider
            .volume-percentage {
            background: coral;
            height: 100%;
            width: 75%;
          }
          .audio-player .controls .volume-container:hover .volume-slider {
            left: -123px;
            width: 120px;
          }
    `
                }
            </style>
        </Fragment>
    );
};

export default Article;
